import React, { Component } from "react";
import { InView } from "react-intersection-observer";
import "styled-components/macro";

import KeyboardKey3D from "./KeyboardKey3D";
import MockBrowser from "./MockBrowser";
import guessMyDevice from "./utils/guess-my-device";
import sizes from "./utils/sizes";

export default class MockKeysAndBrowser extends Component {
  animationDuration = 13640;
  animationDurationPartial = this.animationDuration / 11;

  initialState = {
    keyAction: "",
    animationCycles: 1,
  };

  state = this.initialState;
  height = 236;
  timeouts = [];
  device = guessMyDevice();

  render() {
    const { keyAction, animationCycles } = this.state;

    return (
      <InView
        as="div"
        threshold={0.2}
        initialInView
        onChange={this.handleViz}
        css={`
          z-index: 2;
          position: absolute;
          top: ${this.device === "mobile" ? '240px' : '40%'};
          bottom: ${this.device === "mobile" ? "unset" : `${this.height}px`};
          left: 50%;
          transform: scale(${this.device === "desktop" ? "1" : this.device === 'tablet' ? '0.8' : this.device === 'mobile' ? "0.3" : 1});
        `}
      >
        <div
          css={`
            position: relative;
            width: ${sizes[this.device].landscape}px;
            margin-left: -50%;
            height: ${this.height}px;
          `}
        >
          {/* Mock Keyboard Keys */}
          <div
            css={`
              z-index: 1;
              position: absolute;
              ${this.calcKeysAbsolutePosition()};
            `}
          >
            <KeyboardKey3D
              top={50}
              left={97}
              zIndex={1}
              scale={1.2}
              opacity={0.8}
              keyAction="backout"
              hasReceivedSimulatedPress={this.hasReceivedSimulatedPressCalc(
                "backout"
              )}
              keyPressUpAll={this.keyPressUpAll}
            />
            {/* Disabled key */}
            <KeyboardKey3D
              top={56}
              left={-98}
              zIndex={3}
              scale={0.95}
              rotateZ={-1}
              opacity={0.7}
              hasReceivedSimulatedPress={false}
            />

            {/* Disabled key */}
            <KeyboardKey3D
              top={-4}
              left={-25}
              zIndex={2}
              scale={1}
              rotateZ={-1}
              opacity={0.6}
              hasReceivedSimulatedPress={false}
            />
            <KeyboardKey3D
              top={218}
              left={120}
              zIndex={3}
              scale={2}
              rotateZ={3}
              keyAction="interface_appear"
              hasReceivedSimulatedPress={this.hasReceivedSimulatedPressCalc(
                "interface_appear"
              )}
              keyPressUpAll={this.keyPressUpAll}
            />
            <KeyboardKey3D
              top={200}
              left={-94}
              zIndex={4}
              scale={2.17}
              keyAction="choose"
              hasReceivedSimulatedPress={this.hasReceivedSimulatedPressCalc(
                "choose"
              )}
              keyPressUpAll={this.keyPressUpAll}
            />
            {/* Disabled key */}
            <KeyboardKey3D
              top={214}
              left={-234}
              zIndex={4}
              scale={1.7}
              opacity={1}
              rotateZ={-4}
              hasReceivedSimulatedPress={false}
              keyPressUpAll={this.keyPressUpAll}
            />

            <KeyboardKey3D
              top={370}
              left={83}
              zIndex={4}
              scale={1.6}
              keyAction="scroll_forwards"
              hasReceivedSimulatedPress={this.hasReceivedSimulatedPressCalc(
                "scroll_forwards"
              )}
              keyPressUpAll={this.keyPressUpAll}
            />
            <KeyboardKey3D
              top={402}
              left={-85}
              zIndex={4}
              scale={1.8}
              rotateZ={-3}
              keyAction="scroll_backwards"
              hasReceivedSimulatedPress={this.hasReceivedSimulatedPressCalc(
                "scroll_backwards"
              )}
              keyPressUpAll={this.keyPressUpAll}
            />
          </div>
          {/* Mock Browser */}
          <MockBrowser
            keyAction={keyAction}
            animationCycles={animationCycles}
          // scale={this.device !== "mobile" ? "1" : "0.3"}
          />
        </div>
      </InView>
    );
  }
  componentDidMount() {
    // Wait 1.5s after mounting
    // before kicking off animation
    setTimeout(() => {
      // Initial animation run
      this.startAnimation();
      setInterval(() => {
        const { animationCycles } = this.state;

        // Rerun animation 5 more times
        if (animationCycles < 5)
        {
          this.setState(
            { animationCycles: animationCycles + 1 },
            this.startAnimation
          );
        }
      }, this.animationDuration + 3000);
    }, 1500);
  }

  componentDidUpdate(prevProps, prevState) {
    const { animationCycles } = this.state;

    // if it's finished one cycle
    if (animationCycles > prevState.animationCycles)
    {
      // reset state
      this.setState({ keyAction: "" });
      // kill all timeouts
      this.resetTimeouts();
    }
  }

  startAnimation = () => {
    // create timeouts for each
    // run animation!
    // at end of animation, increment this.state.animationCycles

    this.timeouts = [];

    this.timeouts.push(
      setTimeout(() => {
        this.setState({
          keyAction: "interface_appear",
        });
        this.timeouts.push(
          setTimeout(() => {
            // ...scroll sidebar
            this.setState({ keyAction: "scroll_forwards" });
            this.timeouts.push(
              setTimeout(() => {
                // ...scroll sidebar
                this.setState({ keyAction: "scroll_forwards" });
                this.timeouts.push(
                  setTimeout(() => {
                    // ...scroll sidebar
                    this.setState({ keyAction: "scroll_backwards" });
                    this.timeouts.push(
                      setTimeout(() => {
                        // choose folder
                        this.setState({ keyAction: "choose" });
                        this.timeouts.push(
                          setTimeout(() => {
                            // ...scroll article cards
                            this.setState({ keyAction: "scroll_forwards" });
                            this.timeouts.push(
                              setTimeout(() => {
                                // ...scroll article cards
                                this.setState({ keyAction: "scroll_forwards" });
                                this.timeouts.push(
                                  setTimeout(() => {
                                    // expand full article
                                    this.setState({ keyAction: "choose" });
                                    this.timeouts.push(
                                      setTimeout(() => {
                                        this.setState({ keyAction: "backout" });
                                        this.timeouts.push(
                                          setTimeout(() => {
                                            this.setState({
                                              keyAction: "backout",
                                            });
                                            this.timeouts.push(
                                              setTimeout(() => {
                                                this.setState({
                                                  keyAction: "backout",
                                                });
                                              }, this.animationDurationPartial)
                                            );
                                          }, this.animationDurationPartial)
                                        );
                                      }, this.animationDurationPartial)
                                    );
                                  }, this.animationDurationPartial)
                                );
                              }, this.animationDurationPartial)
                            );
                          }, this.animationDurationPartial)
                        );
                      }, this.animationDurationPartial)
                    );
                  }, this.animationDurationPartial)
                );
              }, this.animationDurationPartial)
            );
          }, this.animationDurationPartial)
        );
      }, this.animationDurationPartial)
    );
  };

  resetTimeouts = () => {
    this.timeouts.forEach((timer) => {
      clearTimeout(timer);
    });
  };

  hasReceivedSimulatedPressCalc = (keyAction) => {
    return this.state.keyAction === keyAction;
  };

  keyPressUpAll = () => {
    this.setState({ keyAction: "" });
  };
  calcKeysAbsolutePosition = () => {

    const top = this.device === "desktop" ? 130 : this.device === 'tablet' ? 130 : this.device === 'mobile' ? 130 : 0;
    const left = this.device === "desktop" ? 140 : this.device === 'tablet' ? -140 : this.device === 'mobile' ? -620 : 0;

    return `top: ${top}px; left: ${left}px;`;
  };
}
